import { Card } from '@/components/Ui';
import React from 'react';
import { NavLink } from 'react-router-dom';

type StatCardProps = {
  icon?: string;
  title: string;
  styleTitle?: string;
  value: number | undefined;
  valueColor?: string;
  percentage?: number;
  percentageColor?: string;
  percentageIcon?: string;
  referenceValue?: number;
  showPercentage?: boolean;
  cardStyle?: string;
  studentsCount?: number;
  showDetailsLink?: boolean;
  href?: string;
};

const StatCard = ({
  icon,
  title,
  styleTitle = 'text-mediumGrey',
  value,
  valueColor = 'text-white',
  percentage = 0,
  percentageColor,
  percentageIcon = 'pi pi-arrow-circle-up',
  referenceValue = 4320,
  showPercentage = false,
  cardStyle = '',
  studentsCount,
  showDetailsLink = false,
  href,
}: StatCardProps) => (
  <Card className={cardStyle}>
    <div className={`grid items-center ${!icon ? 'p-4' : 'p-0'}`}>
      <span className="self-end justify-self-end">
        {icon && <img src={icon} alt="Icon" />}
      </span>
      <div className="mt-[-1rem]">
        <h3
          className={`${styleTitle} text-[15.05px] font-medium text-left uppercase`}
        >
          {title}
        </h3>
        <p
          className={`${valueColor} text-[33.13px] font-bold leading-[38.9px] text-left pb-2`}
        >
          {value} {showPercentage ? <span className="text-xl">%</span> : null}
        </p>
        {showPercentage && percentage > 0 ? (
          <div className="flex items-center text-mediumGrey gap-1 text-[16.621px] font-normal leading-[normal]">
            <i className={percentageIcon} style={{ color: '#4AB58E' }}></i>
            <span className={percentageColor}>{percentage}%</span>
            De <span className="text-[16.621px]">{referenceValue}</span>
          </div>
        ) : null}
        <div
          className={`flex ${studentsCount ? 'justify-between' : 'justify-end'} items-center gap-1`}
        >
          {studentsCount || studentsCount === 0 ? (
            <div className="text-mediumGrey text-[16.621px] font-normal leading-[normal]">
              {studentsCount} élèves
            </div>
          ) : null}
          {showDetailsLink ? (
            <NavLink
              to={href || ''}
              className="text-primary text-xs font-normal underline cursor-pointer"
            >
              Details
            </NavLink>
          ) : null}
        </div>
      </div>
    </div>
  </Card>
);

export default StatCard;
